import { Button, styled } from '@mui/material'
import * as colors from '@mui/material/colors'
import { CSVLink as _CSVLink } from 'react-csv'

export const WordsButton = styled(Button)(({ theme }) => ({
  margin: `0 ${theme.spacing(1)}`,
  color: colors.grey[500],
  backgroundColor: colors.grey[200],
  '&:hover': {
    backgroundColor: colors.grey[300],
  },
  '&.Mui-disabled': {
    backgroundColor: colors.orange[500],
    color: `${colors.grey[50]} !important`,
  },
})) as typeof Button

export const WordsDemoButton = styled(WordsButton)(() => ({
  '&.Mui-disabled': {
    backgroundColor: colors.brown[500],
    color: `${colors.grey[50]} !important`,
  },
})) as typeof Button

export const CSVLink = styled(_CSVLink)(() => ({
  position: 'absolute',
  width: '100%',
  height: '100%',
}))
